import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook для навигации с поддержкой возврата назад
 */
export function useNavigation() {
  const [canGoBack] = useState(
    () => typeof window !== 'undefined' && window.history.length > 1,
  );
  const navigate = useNavigate();

  /**
   * Функция для возврата на предыдущую страницу
   * @param fallbackRoute - роут для fallback если нет истории браузера
   */
  const goBack = useCallback((fallbackRoute?: string) => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      window.history.back();
    }
    else if (fallbackRoute) {
      navigate(fallbackRoute);
    }
  }, [navigate]);

  return {
    goBack,
    canGoBack,
  };
}
